<script>
import liff from "@line/liff";
export default {
    name: "Welcome",
    data() {
        return {
            popup: false
        };
    },
    computed: {
        userNbInfo() {
            return this.$store.state.userNbInfo;
        },
        migoBindLiffId() {
            return this.$store.state.migoBindLiffId;
        },
    },
    watch: {
        userNbInfo: function () {
            let vm = this;
            if (vm.userNbInfo.data.user.isBind) {
                vm.$router.push("/");
            }
        },
    },
    methods: {
        welcome_popup(){
            this.popup = true
        },
        closePopup(){
            // this.popup = false
            liff.closeWindow()
        }
    }
};
</script>
<template src="./template.pug" lang="pug"></template>
<style src="./style.sass" lang="sass" scoped></style>
